import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=3065d6cf&scoped=true&"
import script from "./CommonLayout.vue?vue&type=script&lang=js&"
export * from "./CommonLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=3065d6cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065d6cf",
  null
  
)

export default component.exports